// Pinned waypoint bearings (Waypoint.bearing_azimuth_deg) are only valid for
// the hops pathfinder planned them on. A hand edit — moving, adding or
// deleting a waypoint, moving a core, reversing the path — changes those
// hops, so the bearings on the touched waypoints (and on their immediate
// neighbours, whose hops end or start there) are dropped and the robot
// falls back to deriving the heading from its neighbours
// (calc_waypoint_angle), exactly as it did before pinning existed.
import type Mission from '../db/MissionClass';
import { cleanSet } from '../utils';

function clear(mission: Mission, wanted: (waypointNumber: number) => boolean) {
  for (const waypoint of cleanSet(mission.getWaypoints())) {
    if (waypoint.bearing_azimuth_deg !== undefined && wanted(waypoint.waypoint_number)) {
      waypoint.bearing_azimuth_deg = undefined;
    }
  }
}

// Clear exactly the named waypoints (by waypoint_number).
export function clearBearings(mission: Mission, waypointNumbers: number[]) {
  const wanted = new Set(waypointNumbers);
  clear(mission, (n) => wanted.has(n));
}

// Clear the named waypoints and their immediate neighbours (n - 1, n, n + 1):
// the hop into and the hop out of a moved or inserted waypoint both change.
export function clearBearingsAround(mission: Mission, waypointNumbers: number[]) {
  const wanted = new Set<number>();

  for (const n of waypointNumbers) {
    wanted.add(n - 1);
    wanted.add(n);
    wanted.add(n + 1);
  }

  clear(mission, (n) => wanted.has(n));
}

export function clearAllBearings(mission: Mission) {
  clear(mission, () => true);
}
